"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxemitter_1 = require("./rxemitter");
function RxSubscribe(a, b, c) {
    if (b === void 0) { b = false; }
    if (c === void 0) { c = null; }
    return function (target, name, descriptor) {
        var eventObj = typeof a == 'object' ? a : { eventName: a, unsubscribe: b, target: c };
        var eventName = eventObj.name || eventObj.event || eventObj.eventName;
        var subscription = rxemitter_1.RxEmitter.on(eventName, eventObj.target).subscribe(descriptor.value.bind(target));
        if (eventObj.target) {
            var cache = rxemitter_1.RxEmitter.get(eventName);
            cache.subscription = subscription;
        }
        if (eventObj.unsubscribe === true ||
            eventObj.unsubscribe == 'unsubscribe' ||
            eventObj.unsubscribe == 'destroy' ||
            eventObj.unsubscribe == 'off' ||
            eventObj.unsubscribe == 'remove') {
            var oldNgOnDestroy_1 = target.ngOnDestroy;
            target.ngOnDestroy = function () {
                oldNgOnDestroy_1 && oldNgOnDestroy_1.call(this);
                subscription.unsubscribe();
            };
        }
    };
}
exports.RxSubscribe = RxSubscribe;
//# sourceMappingURL=rxsubscribe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxemitter/rxsubscribe.js
// module id = 1312
// module chunks = 0